// extracted by mini-css-extract-plugin
module.exports = {"hidden":"chatbot_hidden__gJHVv","chatFrame":"chatbot_chatFrame__Yv6Se"};